import React from "react";
import { Link } from "react-router-dom";
import PublicPageLayout from "@/components/PublicPageLayout";
import Seo, { pageSchema } from "@/components/Seo";
import { WhatsAppButton } from "@/components/WhatsAppFab";
import { Button } from "@/components/ui/button";
import { WA_MESSAGES } from "@/lib/site";

export default function About() {
  const path = "/about";
  const title = "About Us | Registry Feed | Newly Registered Company Database";
  const description = "Registry Feed is a B2B company data platform focused on newly registered MCA and GST businesses in India. Learn what we build, who we serve and how we operate.";
  const bc = [{ name: "Home", path: "/" }, { name: "About", path }];
  const jsonLd = pageSchema({ title, description, path, breadcrumbs: bc });
  return (
    <PublicPageLayout breadcrumbs={bc}>
      <Seo title={title} description={description} path={path} jsonLd={jsonLd} />
      <section className="mx-auto max-w-3xl px-4 sm:px-6 py-14 sm:py-20">
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight">About Registry Feed</h1>
        <div className="prose prose-slate dark:prose-invert mt-6 max-w-none">
          <p>Registry Feed is a B2B company data platform. We compile a daily feed of newly registered businesses in India — both MCA incorporations and GST registrations — and deliver clean CSV files through a simple dashboard.</p>
          <h2>What we do</h2>
          <p>We work with publicly filed data from official Registrar of Companies (ROC) and Goods and Services Tax Network (GSTN) sources. We standardise, deduplicate and organise it into daily datasets that our subscribers can filter by geography and download as Excel-friendly CSV.</p>
          <h2>Who we serve</h2>
          <p>Sales teams, chartered accountants, banks, NBFCs, DSAs, SaaS companies, marketing agencies, insurance providers and other B2B teams that want to reach fresh businesses on day one.</p>
          <h2>How we operate</h2>
          <ul>
            <li>Daily uploads of newly registered companies.</li>
            <li>All 36 Indian states and union territories.</li>
            <li>All ROC jurisdictions.</li>
            <li>30-day access per subscription.</li>
            <li>Simple pricing — pay per data stream, per month.</li>
          </ul>
          <p>We do not claim government affiliation. We do not guarantee any specific accuracy figure. We do not sell scraped social profiles or personally identifiable information beyond what is publicly filed.</p>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <WhatsAppButton message={WA_MESSAGES.general} label="Talk to us" />
          <Link to="/how-it-works"><Button variant="outline">How it works</Button></Link>
        </div>
      </section>
    </PublicPageLayout>
  );
}
